<template>
  <div>
    <b-row v-if="isRequired && estudios">
      <b-col cols="12">
        <b-row>
          <b-col
            xl="12"
            lg="12"
            md="12"
            sm="12"
          >
            <b-alert
              show
              variant="primary"
            >
              <div class="alert-body">
                <feather-icon
                  class="mr-25"
                  icon="BookIcon"
                />
                <span class="ml-25">Estudios</span>
              </div>
            </b-alert>
          </b-col>
        </b-row>
      </b-col>

      <b-col cols="4">
        <div class="mx-1 my-0">
          <h5 class="text-capitalize mb-75">
            Nivel de estudios:
          </h5>
          <b-card-text>
            {{ estudios.nivel_estudios.descripcion }}
          </b-card-text>
          <h5 class="text-capitalize mb-75">
            Comprobante de Estudios :
          </h5>
          <b-card-text>
            {{ estudios.tipo_comprobante.descripcion }}
          </b-card-text>
          <h5 class="text-capitalize mb-75">
            Perfil:
          </h5>
          <b-card-text>
            {{ data.detalles ? data.detalles : 'SIN DATOS' }}
          </b-card-text>
        </div>
      </b-col>
      <b-col cols="4">
        <h5 class="text-capitalize mb-75">
          Fecha de inicio estudios:
        </h5>
        <b-card-text>
          {{ estudios.fecha_inicio_estudios || 'No aplica' }}
        </b-card-text>
        <h5 class="text-capitalize mb-75">
          Fecha de termino estudios:
        </h5>
        <b-card-text>
          {{ estudios.fecha_termino_estudios || 'No aplica' }}
        </b-card-text>
        <h5 class="text-capitalize mb-75">
          Estado donde curso:
        </h5>
        <b-card-text>
          {{ estudios.estado_curso || 'No aplica' }}
        </b-card-text>
      </b-col>
      <b-col cols="4">
        <h5 class="text-capitalize mb-75">
          Nombre de la institución:
        </h5>
        <b-card-text>
          {{ estudios.nombre_institucion || 'No aplica' }}
        </b-card-text>
      </b-col>
    </b-row>
    <b-row v-else>
      <b-col cols="12">
        <b-alert
          show
          variant="primary"
        >
          <div class="alert-body">
            <feather-icon
              class="mr-25"
              icon="BookIcon"
            />
            <span class="ml-25">Estudios</span>
          </div>
        </b-alert>
      </b-col>
      <b-col>
        <h5 class="ml-1">
          Esta convocatoria no requiere estos datos.
        </h5>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import {
  BAlert, BCol, BCardText, BRow,
} from 'bootstrap-vue'

export default {
  name: 'EstudiosPrebecario',
  components: {
    BAlert,
    BCol,
    BCardText,
    BRow,
  },
  props: {
    id: {
      type: [Number, String],
      required: true,
    },
    data: {
      type: [Object, Array],
      default: () => {},
    },
    isRequired: {
      type: Boolean,
      default: () => false,
    },
  },
  data() {
    return {
      estudios: null,
    }
  },
  mounted() {
    this.estudios = { ...this.data }
  },
  methods: {
    updateEstudios(resp) {
      this.estudios.nivel_estudios = resp.nivelEstudios
      this.estudios.tipo_comprobante = resp.tipoComprobante
    },
  },
}
</script>

<style lang="scss" scope>
@import '@core/scss/vue/libs/vue-select.scss';
</style>
